import type { StaticLayerPayload } from "@config";
import { BeforeAfterLibrary } from "@library-elements/before-after";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: BeforeAfterLibrary,
};

export const BeforeAfter = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
